import { render, staticRenderFns } from "./AddToSalesgear.vue?vue&type=template&id=5c9f0e66"
import script from "./AddToSalesgear.vue?vue&type=script&lang=js"
export * from "./AddToSalesgear.vue?vue&type=script&lang=js"
import style0 from "./AddToSalesgear.vue?vue&type=style&index=0&id=5c9f0e66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports